import React, { Component } from "react";
import {
  Wrapper,
  Card,
  PrimaryButton,
  Button,
  CardBody,
  Copy,
  Bold,
  Row
} from "app/NativeComponents/common";
import { TextButton } from "app/NativeComponents/snippets";

import { displayIntercom } from "app/NativeActions";

class Buttons extends Component {
  renderChatButton() {
    if (this.props.platform == "ios") {
      return (
        <Button onPress={() => displayIntercom()} id="intercom_button">
          <CardBody
            style={{
              paddingTop: 0
            }}
          >
            <Wrapper
              style={{
                alignItems: "center",
                justifyContent: "center"
              }}
            >
              <Copy
                style={{
                  textAlign: "center"
                }}
              >
                Need help? Chat with us.
              </Copy>
            </Wrapper>
          </CardBody>
        </Button>
      );
    }
  }

  renderSignupButton() {
    if (this.props.device == "desktop") {
      return (
        <Row>
          <Copy style={{ textAlign: "left", fontSize: 12 }}>
            Don't have an account?
          </Copy>
          <Button
            style={{ marginLeft: 5 }}
            onPress={() => {
              this.props.appRedirect({ redirect: "signUp" });
            }}
          >
            <Row>
              <Copy style={{ textAlign: "left", fontSize: 12 }}>
                <Bold>Sign Up</Bold>
              </Copy>
            </Row>
          </Button>
        </Row>
      );
    }
  }

  render() {
    return (
      <Wrapper>
        <Card style={{ borderRadius: 30, overflow: "hidden" }}>
          <PrimaryButton formButton onPress={() => this.props.login()}>
            Log in
          </PrimaryButton>
        </Card>

        <Row
          style={{
            justifyContent:
              this.props.device == "desktop" ? "space-between" : "center",
            padding: 20
          }}
        >
          <Button
            onPress={() => {
              this.props.appRedirect({ redirect: "forgotPassword" });
            }}
          >
            <Row>
              <Copy style={{ textAlign: "left", fontSize: 12 }}>
                Forgot Password
              </Copy>
            </Row>
          </Button>
          {this.renderSignupButton()}
        </Row>

        {this.renderChatButton()}
      </Wrapper>
    );
  }
}

export default Buttons;
